(function ($) {
  
  const swiper = new Swiper('.swiper.product-list', {
      slidesPerView: 6,
      spaceBetween: 0,
      loop:true,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      breakpoints: {
        0: {
          slidesPerView: 1,
          spaceBetween: 0,
        },
        768: {
          slidesPerView: 2,
          spaceBetween: 0,
        },
        1024: {
          slidesPerView: 6,
          spaceBetween: 0,
        },
      },
  });
  
  const topswiper = new Swiper('.top-slider .swiper', {
      slidesPerView: 4,
      spaceBetween: 0,
      loop:true,
      pauseOnMouseEnter: true,
      autoplay: {
       delay: 1000,
      },
      breakpoints: {
        0: {
          slidesPerView: 1,
          spaceBetween: 0,
        },
        768: {
          slidesPerView: 2,
          spaceBetween: 0,
        },
        1024: {
          slidesPerView: 4,
          spaceBetween: 0,
        },
      },
  });
  
  const bottomswiper = new Swiper('.bottom-slider .swiper', {
      slidesPerView: 4,
      spaceBetween: 0,
      loop:true,
      autoplay: {
       delay: 1500,
      },
      pauseOnMouseEnter: true,
      reverseDirection: true,
      breakpoints: {
        0: {
          slidesPerView: 1,
          spaceBetween: 0,
        },
        768: {
          slidesPerView: 2,
          spaceBetween: 0,
        },
        1024: {
          slidesPerView: 4,
          spaceBetween: 0,
        },
      },
  });
  
  $('#dropdown-btn').on('click', function(e) {
    e.preventDefault();
    $('.dropdown-section').slideToggle(300);
  });
  
  $('.dropdown-section li').on('click', function(e) {
    e.preventDefault();
    var selectedText = $(this).html();
    $('#dropdown-btn').html(selectedText);
    $('.form-block').slideDown(300);
    $('#form-title span').html(selectedText);
    $('#contact_subject').val(selectedText);
    $('.dropdown-section').slideToggle(300);
  });
  
  $('#add').on('click', function() {
    $("#addcart-popup").fadeIn(300).delay(2000).fadeOut();
  });
  
  /*
  $('.quick-add').on('click', function(e) {
    e.preventDefault();
    $("#addcart-popup").fadeIn(300).delay(2500).fadeOut();
    return true;
  });
  */
  
})(theme.jQuery);  
